import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { Icon, Header, Popup, Button } from 'semantic-ui-react';
import Logo from '../Logo';
import { toggleSidebar } from '../../actions/ui/sidebar';
import { sync } from '../../actions/ui/sync';
import { isSignedIn } from 'features/user/state/User.selector';
import './index.css';

const AppHeader = ({
  label,
  isMobile,
  isAuthenticated,
  isSyncRunning,
  hasPendingChanges,
  lastSyncError,
  toggleSidebar,
  sync
}) => {
  const auth0 = useAuth0();
  const loginWithRedirect =
    auth0 && typeof auth0.loginWithRedirect === 'function' ? auth0.loginWithRedirect : null;

  const popupContent =
    isAuthenticated && lastSyncError ? (
      <div>
        <div style={{ marginBottom: '0.5rem' }}>{lastSyncError}</div>
        {loginWithRedirect && (
          <>
            <div style={{ marginBottom: '0.5rem', fontSize: '0.9em' }}>
              Sign in again to get a fresh token and enable sync.
            </div>
            <Button
              size="small"
              primary
              onClick={() => loginWithRedirect({ authorizationParams: { prompt: 'login' } })}
            >
              Sign in again
            </Button>
          </>
        )}
      </div>
    ) : (
      lastSyncError || (hasPendingChanges ? 'Sync to cloud' : 'Sync with cloud')
    );

  return (
    <header>
      <Header>
        {isMobile && <Icon name="bars" onClick={toggleSidebar} />}
        {!isMobile && <Logo />}
        <Header.Content as="h2">{label}</Header.Content>
        {isAuthenticated &&
          (isSyncRunning ? (
            <Icon name="refresh" loading />
          ) : (
            <Popup
              content={popupContent}
              trigger={
                <Icon
                  name="refresh"
                  color={lastSyncError ? 'red' : hasPendingChanges ? 'olive' : undefined}
                  onClick={sync}
                  style={{ cursor: 'pointer' }}
                />
              }
              on="hover"
            />
          ))}
      </Header>
    </header>
  );
};

AppHeader.propTypes = {
  label: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  isSyncRunning: PropTypes.bool,
  hasPendingChanges: PropTypes.bool,
  lastSyncError: PropTypes.string,
  toggleSidebar: PropTypes.func,
  sync: PropTypes.func
};

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  isMobile: state.ui.isMobile,
  isAuthenticated: isSignedIn(state),
  isSyncRunning: state.ui.sync.isRunning,
  hasPendingChanges: state.ui.sync.hasPendingChanges,
  lastSyncError: state.ui.sync.lastError
});

export default connect(
  mapStateToProps,
  { toggleSidebar, sync }
)(AppHeader);
